import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'svg-inline-react';
import InfoSvg from '@src/svgs/fr-info-icon.svg';
import { OpeningCandidateDestinationTypeEnum } from '@src/graphql/generated';
import './styles.scss';

export function CandidateDestinationInfo({ candidateDestination }) {
  if (candidateDestination.type === OpeningCandidateDestinationTypeEnum.MEETFRANK) {
    return null;
  }

  return (
    <div className="candidate-destination-info">
      <Svg className="candidate-destination-info__icon" src={InfoSvg} />
      <div className="candidate-destination-info__text">
        Applicants for this opening will be applying outside of MeetFrank.
      </div>
    </div>
  );
}

CandidateDestinationInfo.propTypes = {
  candidateDestination: PropTypes.object.isRequired,
};
